/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { ConfigProvider, useConfig } from '@revenuewell/logic-config';
import { ProgressProvider, useProgress } from '@revenuewell/logic-progress';
import { AppStateProvider } from '@revenuewell/logic-app-state';
import { OidcProvider } from '@revenuewell/logic-oidc';
import { NotificationProvider } from '@revenuewell/logic-notification';
import { ConfirmationProvider } from '@revenuewell/logic-confirmation';
import { DesktopProvider, useDesktop } from '@revenuewell/logic-desktop';

/* eslint-disable-next-line */
export interface AuthAppProviderProps {
  isProduction: boolean;
  devConfig: unknown;
  prodConfigPath: string;
}

function CoreProviders(props: React.PropsWithChildren<AuthAppProviderProps>) {
  return (
    <DesktopProvider isDesktopWidget={false}>
      <NotificationProvider>
        <ConfirmationProvider>
          <ProgressProvider>
            <AppStateProvider>
                <ConfigProvider
                  isProduction={props.isProduction}
                  devConfig={props.devConfig}
                  prodConfigPath={props.prodConfigPath}
                >
                  {props.children}
                </ConfigProvider>
            </AppStateProvider>
          </ProgressProvider>
        </ConfirmationProvider>
      </NotificationProvider>
    </DesktopProvider>
  );
}

function ConfigDependantCoreProviders(
  props: React.PropsWithChildren<AuthAppProviderProps>
) {
  const { config } = useConfig();
  const { showAppSpinner } = useProgress();

  useEffect(() => {
    showAppSpinner();
  }, []);

  return (
    <>
      {config && (
        <OidcProvider oidcConfig={config.oidc}>{props.children}</OidcProvider>
      )}
    </>
  );
}


export function SignInRedirectProviders(props: React.PropsWithChildren<AuthAppProviderProps>) {
    return (
        <CoreProviders {...props}>
            <ConfigDependantCoreProviders {...props}>
                {props.children}
            </ConfigDependantCoreProviders>
        </CoreProviders>
    );
}
